const DefaultItems = [
	{
      amount: 300.00,
      category: "grocery",
      createdAt: new Date(),
      details: "Weekly groceries",
      id: "0d804a4b-19ff-47b1-84e4-ce79413b9dc0",
      title: "Groceries",
   },
   {
      amount: 165.00,
      category: "transportation",
      createdAt: new Date(),
      details: "Monthly payment",
      id: "w2d27c39-b4c7-4f07-92d2-m86b96be024b",
      title: "Auto Insurance",
   },
   {
      amount: 200.00,
      category: "entertainment",
      createdAt: new Date(),
      details: "Lorem Ipsum Music Festival",
      id: "61a71eb1-60c0-4d54-b55a-3571c1679fa7",
      title: "Music Festival Tickets",
   },
   {
      amount: 80.00,
      category: "utilities",
      createdAt: new Date(),
      details: "Monthly Internet Plan",
      id: "2a304a4b-19ff-47b1-84e4-zb79413b9dc0",
      title: "Fibrestream Internet",
   },
   {
      amount: 300.00,
      category: "other",
      createdAt: new Date(),
      details: "Purchased a new winter jacket.",
      id: "36d6bea0-2ad4-4523-a417-4ae35c15316e",
      title: "Winter Jacket",
   },
   {
      amount: 100.00,
      category: "utilities",
      createdAt: new Date(),
      details: "",
      id: "32a71eb1-60c0-4d54-b55a-1171c1679fa4",
      title: "Mobile Phone Bill",
   },
   {
      amount: 400.00,
      category: "entertainment",
      createdAt: new Date(),
      details: "Saturday Night",
      id: "c0d27c39-b4c7-4f07-92d2-d86b96be027e",
      title: "Leafs Game Tickets",
   },
   {
      amount: 350.00,
      category: "grocery",
      createdAt: new Date(),
      details: "Food stock up",
      id: "u2d27c39-b4c7-4f07-92d2-m86b96be027t",
      title: "Costco Groceries",
   },
   {
      amount: 2200.00,
      category: "housing",
      createdAt: new Date(),
      details: "",
      id: "5a304a4b-19ff-47b1-84e4-eb79413b9dc2",
      title: "Rent/Mortgage Payment",
   },
   {
      amount: 35.00,
      category: "transportation",
      createdAt: new Date(),
      details: "Commute home from dinner",
      id: "10z6bea0-2ad4-4523-a417-1ce35c15316e",
      title: "Uber Ride",
   },
];

export default DefaultItems;